import React from "react";

export const SCORE_COLORS: Record<string, string> = {
  Poor: "text-red-400",
  Fair: "text-orange-400",
  Good: "text-yellow-400",
  Great: "text-blue-400",
  Perfect: "text-green-400",
};

export function renderCriteriaTooltip(instructions: string) {
  const parts = instructions.split("\n\n");
  const description = parts[0] || "";
  const scoreLines = (parts[1] || "")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);

  const scores = scoreLines
    .map((line) => {
      const m = line.match(/^Score\s+(\d)\s+\((\w+)\):\s*(.+)$/);
      if (!m) return null;
      return { value: m[1], label: m[2], text: m[3] };
    })
    .filter(Boolean) as { value: string; label: string; text: string }[];

  if (scores.length === 0) return instructions;

  return (
    <div className="flex gap-5 min-w-[600px]">
      <div className="w-[240px] shrink-0">
        <p className="text-sm leading-relaxed">{description}</p>
      </div>
      <div className="flex-1 border-l border-white/10 pl-4">
        <table className="text-xs">
          <tbody>
            {scores.map((s) => (
              <tr key={s.value}>
                <td
                  className={`pr-2 py-0.5 font-semibold whitespace-nowrap ${SCORE_COLORS[s.label] || ""}`}
                >
                  {s.value} — {s.label}
                </td>
                <td className="py-0.5 text-white/70">{s.text}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
